
<template>
    <div>
      <IKFiltroFuncionario ref="ikFiltroFuncionario"/>      
      <h6 class="p-text-bold">Período</h6>  
      <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col">
              <label>Dia início</label>
              <Calendar v-model="dataInicio" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy" :locale="localeCalendarBR"/>				
          </div>
          <div class="p-field p-col">
              <label>Dia final</label>
              <Calendar v-model="dataFinal" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy" :locale="localeCalendarBR"/>	
          </div>
      </div>
      <h6 class="p-text-bold p-mt-3">Justificativa</h6>
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-12">
            <Dropdown v-model="idJustificativaSelecionada" :options="justificativas" dataKey="id"
                optionLabel="descricao" optionValue="id" placeholder="Selecione" :filter="true" /> 
        </div>                 
      </div>  
      <div class="p-d-flex p-jc-between">		
          <div>
              <SplitButton label="Gerar" icon="pi pi-plus" :model="opcoesFormato"></SplitButton>
          </div>	
      </div>    
    </div>
  </template>
  
  <script>
  import JustificativaService from '@/service/JustificativaService';
  import RelatorioService from '@/service/RelatorioService';
  import IKFiltroFuncionario from '@/components/template/IKFiltroFuncionario';
  import { exibirMensagem, exibirMensagemSis, preViewArquivo, download, localeCalendarBR } from '@/global';
  import { mapGetters } from 'vuex';
  
  export default {
      relatorioService: null,
      justificativaService: null,
      data() {
          return {
              justificativas: [],       
              idJustificativaSelecionada: null,       
              dataInicio: new Date(),
              dataFinal: new Date(),
              opcoesFormato: [],
              localeCalendarBR: localeCalendarBR
          }
      },
      methods: {
          ...mapGetters('sessao', ['getDadosRequisicao']),       
          exportarPdf() {
              let dados = this.$refs.ikFiltroFuncionario.getFuncionarios();            
              if(dados.funcionarios.length == 0) {
                  exibirMensagemSis(this, 'Selecione um ou mais funcionários', true);
                  return;
              }
              let idsJustificativas = [];
              if(this.idJustificativaSelecionada != 0) {
                idsJustificativas.push(this.idJustificativaSelecionada);
              }
              let idsFuncionarios = [];
              dados.funcionarios.forEach(funcio => {
                  idsFuncionarios.push(funcio.id);
              });
              let requisicao = {         
                  idsJustificativas: idsJustificativas,      
                  dataInicio: this.formatarData(this.dataInicio),
                  dataFinal: this.formatarData(this.dataFinal),
                  idsFuncionarios: idsFuncionarios,
                  ativo: dados.ativo,
                  cnpj: {...dados.cnpj},
                  usuarioRequisicao: {...this.getDadosRequisicao()}
              }
              this.relatorioService.exportarOcorrenciasJustificadasPdf(requisicao)
            .then(resp => {     
                preViewArquivo(resp.data);             
            })
            .catch(erro => {
                if(erro.response.headers['ik-response']) {
                    erro.response.data = JSON.parse(erro.response.headers['ik-response']);
                }
                exibirMensagem(this, erro)
            });
          },
          exportarXls() {
              let dados = this.$refs.ikFiltroFuncionario.getFuncionarios();            
              if(dados.funcionarios.length == 0) {
                  exibirMensagemSis(this, 'Selecione um ou mais funcionários', true);
                  return;
              }
              let idsJustificativas = [];
              if(this.idJustificativaSelecionada != 0) {
                idsJustificativas.push(this.idJustificativaSelecionada);
              }
              let idsFuncionarios = [];
              dados.funcionarios.forEach(funcio => {
                  idsFuncionarios.push(funcio.id);
              });
              let requisicao = {         
                  idsJustificativas: idsJustificativas,      
                  dataInicio: this.formatarData(this.dataInicio),
                  dataFinal: this.formatarData(this.dataFinal),
                  idsFuncionarios: idsFuncionarios,
                  ativo: dados.ativo,
                  cnpj: {...dados.cnpj},
                  usuarioRequisicao: {...this.getDadosRequisicao()}
              }
              this.relatorioService.exportarOcorrenciasJustificadasXls(requisicao)
                .then(resp => {     
                    download(resp.data, resp.headers['ik-response']);            
                })
                .catch(erro => {
                    if(erro.response.headers['ik-response']) {
                        erro.response.data = JSON.parse(erro.response.headers['ik-response']);
                    }
                    exibirMensagem(this, erro)
                });
          },
          listarJustificativas() {					
			this.justificativaService.listar({...this.getDadosRequisicao()})
            .then(resp => {
                this.justificativas = [];
                this.idJustificativaSelecionada = 0;
                let justiTodos = { id: 0, descricao: 'Todos' };
                this.justificativas.push(justiTodos);
                Array.prototype.push.apply(this.justificativas, resp.data);                
            })
            .catch(erro => {exibirMensagem(this, erro)});   
		  },
          configurarOpcoes() {
            this.opcoesFormato = [
                {
                    label: 'Pdf',
                    icon: 'pi pi-file-pdf',
                    command: () => {
                        this.exportarPdf();
                    }
                },          
                {
                    label: 'Excel',
                    icon: 'pi pi-file',
                    command: () => {
                        this.exportarXls();
                    }
                },
            ];                
          },
          formatarData(data) {
              if(!data) {
                  return null;
              }
              let strData = null;
              if(data instanceof Date) {
                  let dt = data;
                  let mes = dt.getMonth();
                  let dia = dt.getDate();
                  strData = dt.getFullYear() + '-' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '-' + (dia < 10 ? '0' + dia : '' + dia);
              } else {
                  let partes = data.split('/');
                  strData = partes[2] + '-' + partes[1] + '-' + partes[0];
              }
              return strData;
          }
      },
      created() {
          this.relatorioService = new RelatorioService();
          this.justificativaService = new JustificativaService();	
          this.configurarOpcoes();
      },
      mounted() {
        this.listarJustificativas();
      },
      components: {
          'IKFiltroFuncionario': IKFiltroFuncionario,
      }
  }
  </script>
  
  <style>
  
  </style>